<template>
    <ContactUsSection />
    <DiagnosisSection />
    <MakeDiagnosisSection />
    <YourResultsSection />
    <WaySection />
</template>

<script>
import DiagnosisSection from '../Como_Funciona/DiagnosisSection.vue';
import MakeDiagnosisSection from '../Como_Funciona/MakeDiagnosisSection.vue';
import YourResultsSection from '../Como_Funciona/YourResultsSection.vue';
import WaySection from '../Como_Funciona/WaySection.vue';

export default {
  name: 'DiagnosisIndex',
  components: {
    DiagnosisSection,
    MakeDiagnosisSection,
    YourResultsSection,
    WaySection
  }
}
</script>